import { render } from "./Table.vue?vue&type=template&id=6981d671&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/NutritionBalances/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6981d671"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6981d671', __exports__)) {
    console.log('reload')
    api.reload('6981d671', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=6981d671&ts=true", () => {
    console.log('re-render')
    api.rerender('6981d671', render)
  })

}


export default __exports__